const subuserStatementsPT = {
    "view": {
        "table": {
            "title": "Lista de Declarações do Seu Subusuário",
            "column": {
                "type": "Tipo",
                "year": "Ano",
                "month": "Mês",
                "issue_year": "Ano de Emissão",
                "issue_month": "Mês de Emissão",
                "description": "Descrição",
                "amount": "Quantia",
                "status": "Status",
                "details": "Detalhes",
                "overview": "Visão Geral",
                "action": "Ação"
            },
            "button": {
                "export_csv": "Exportar CSV",
                "download": "Baixar"
            },
            "placeholder": {
                "search": "Pesquisar..."
            },
            "label": {
                "statusOpen": "Aberto",
                "statusPaid": "Pago",
                "typeLicensing": "Licenciamento",
                "typeRegular": "Regular",
                "typeAudioMasteringServices": "Masterização de Áudio - Serviços",
                "typeVinylEarnings": "Ganhos de Vinil",
                "typeOffset": "Compensação",
                "typeNotKnown": "Desconhecido",
                "monthJanuary": "Janeiro",
                "monthFebruary": "Fevereiro",
                "monthMarch": "Março",
                "monthApril": "Abril",
                "monthMay": "Maio",
                "monthJune": "Junho",
                "monthJuly": "Julho",
                "monthAugust": "Agosto",
                "monthSeptember": "Setembro",
                "monthOctober": "Outubro",
                "monthNovember": "Novembro",
                "monthDecember": "Dezembro"
            },
            "dropdown": {
                "markAsPaid": "Marcar como PAGO",
                "markAsOpen": "Marcar como ABERTO",
                "action": "Ação"
            },
            "message": {
                "statementUnavailable": "Todas as declarações emitidas antes de janeiro de 2023 estão disponíveis como anexos de arquivo ZIP no seu e-mail."
            }
        },
        "message": {
            "successMarkedOpen": "A declaração do subusuário foi marcada como ABERTA!",
            "successMarkedPaid": "A declaração do subusuário foi marcada como PAGA!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!"
        },
        "modal": {
            "markAsPaid": {
                "header": "Marcar declaração como PAGA",
                "body": "Tem certeza de que deseja marcar a declaração {{statementName}} como PAGA?"
            },
            "markAsOpen": {
                "header": "Marcar declaração como ABERTA",
                "body": "Tem certeza de que deseja marcar a declaração {{statementName}} como ABERTA?"
            }
        }
    },
    "viewOnly": {
        "table": {
            "title": "Sua Lista de Declarações",
            "column": {
                "name": "Nome da Declaração",
                "type": "Tipo",
                "quarter": "Trimestre",
                "year": "Ano",
                "month": "Mês",
                "description": "Descrição",
                "amount": "Quantia",
                "status": "Status",
                "overview": "Visão Geral",
                "details": "Detalhes"
            },
            "button": {
                "download": "Baixar",
                "export_csv": "Exportar CSV"
            },
            "placeholder": {
                "search": "Pesquisar..."
            },
            "label": {
                "statusOpen": "Aberto",
                "statusPaid": "Pago",
                "typeLicensing": "Licenciamento",
                "typeRegular": "Regular",
                "typeAudioMasteringServices": "Masterização de Áudio - Serviços",
                "typeVinylEarnings": "Ganhos de Vinil",
                "typeOffset": "Compensação",
                "typeNotKnown": "Desconhecido",
                "quarterQ1": "T1",
                "quarterQ2": "T2",
                "quarterQ3": "T3",
                "quarterQ4": "T4",
                "monthJanuary": "Janeiro",
                "monthFebruary": "Fevereiro",
                "monthMarch": "Março",
                "monthApril": "Abril",
                "monthMay": "Maio",
                "monthJune": "Junho",
                "monthJuly": "Julho",
                "monthAugust": "Agosto",
                "monthSeptember": "Setembro",
                "monthOctober": "Outubro",
                "monthNovember": "Novembro",
                "monthDecember": "Dezembro"
            },
            "message": {
                "statementUnavailable": "Todas as declarações emitidas antes de janeiro de 2023 foram enviadas por e-mail para o seu gerente de conta."
            }
        }
    }
};

export default subuserStatementsPT;